import {Injectable} from '@angular/core';
import {API, HtmlDTO, TemplateStoreDataDTO} from '../api/api';

@Injectable({
  providedIn: 'root'
})

export class ContentEditorService {


  customCSS: string = `
    body {
        overflow: hidden!important;
    }
    `;
  customStyle: string = `<style>${this.customCSS}</style>`;

  headTag: string = '<head>';

  constructor(private api: API) {
  }

  public createHtmlDTO(html: string, width: number, height: number, data: TemplateStoreDataDTO): HtmlDTO {
    const ret: HtmlDTO = this.api.createDTO('HtmlDTO');
    ret.base64 = btoa(html ? html : '');
    ret.width = width;
    ret.height = height;
    ret.templateStoreData = data;
    return ret;
  }

  public injectCustomCSSToEditorData(data: any, css: string = ''): any {
    if (data?.html) {
      data.html = this.injectCustomCSSToHtml(data.html, css);
    }
    return data;
  }

  public injectCustomCSSToHtml(html: string, css: string = ''): string {
    let ret: string;

    ret = html ? (html.includes(this.headTag) ? html.replace(this.headTag, this.headTag + '\n' + this.customStyle + (css ? '\n' + css : '')) : html) : html;

    return ret;
  }
}
